<template>
<div class="submit">
  <div class="submit-form">
    <div class="submit-row">
      <div class="submit-label">Task Title (Optional)</div>
      <div class="submit-right">
        <input class="submit-input" v-model="title">
      </div>
    </div>

    <!-- <div class="submit-row">
      <div class="submit-label">Database</div>
      <div class="submit-right">
        <input type="checkbox" id="chembl" value="CHEMBL" v-model="database">
        <label for="chembl">CHEMBL</label>

        <input type="checkbox" id="metabolites" value="Metabolites" v-model="database">
        <label for="metabolites">Metabolites</label>

        <input type="checkbox" id="zinc" value="Zinc" v-model="database">
        <label for="zinc">Zinc</label>

        <input type="checkbox" id="bindingdb" value="BindingDB" v-model="database">
        <label for="bindingdb">BindingDB</label>
      </div>
    </div>
 -->
    <div class="submit-row">
      <div class="submit-label">Compound</div>
      <div class="submit-right">
        <input class="submit-input" :value="compound" disabled>
      </div>
    </div>

    <!-- <div class="submit-row">
      <div class="submit-label">Similarity Cutoff</div>
      <div class="submit-right">
        <input class="submit-input" v-model="simCutoff">
      </div>
    </div> -->

    <div class="submit-row">
      <div class="submit-label">Compound Similarity Metrics</div>
      <div class="submit-right">
        <!-- <select class="submit-select" v-model="fpType" placeholder="Please Select:">
          <option>FP2</option>
          <option>FP3</option>
        </select> -->
        <el-checkbox-group v-model="fpType">
          <el-checkbox label="fp2" disabled>FP2</el-checkbox>
          <el-checkbox label="pharmacophore">Pharmacophore</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>

    <div class="submit-row">
      <div class="submit-label">Number of Similar Compounds to Search</div>
      <div class="submit-right">
        <input class="submit-input" v-model="num">
      </div>
    </div>
    
    <div class="submit-row">
      <div class="submit-label">Fragmentation</div>
      <div class="submit-right">
        <el-switch v-model="fragmentation"></el-switch>
      </div>
    </div>
    
  </div>
</div>
</template>

<script>
import { bus } from '../bus.js'
import axios from 'axios'

export default {
  name: 'Submit',

  data () {
    return {
      title: '',
      smiles: '',
      database: ['CHEMBL'],
      fpType: ['fp2'],
      simCutoff: 0.1,
      num: 100,
      fragmentation: false
    }
  },

  props: [ 'compound' ],

  computed: {
    frontConfig () {
      return this.$store.state.frontConfig
    }
  },

  methods: {
    setTitle (s) {
      this.title = s
    },

    post (url, p, cb1 = () => {}, cb2 = () => {}) {
      let parts = [new Blob([JSON.stringify(p)], { type: 'application/json' })]
      let fileToSend = new File(parts, 'upload.json', {
        type: 'application/json'
      })

      let formData = new FormData()

      formData.append('par', fileToSend)

      axios({
        method: 'post',
        url,
        data: formData,
        config: {headers: {'Content-Type': 'multipart/form-data'}},
        withCredentials: true
      }).then(response => {
        cb1(response)
      }).catch(error => {
        cb2(error)
      })
    },

    submit () {
      let v = this
      let p = {
        taskType: 0,
        title: v.title,
        smiles: v.smiles,
        compound: v.compound,
        database: v.database,
        fpType: v.fpType,
        simCutoff: v.simCutoff,
        num: v.num,
        fragmentation: v.fragmentation
      }

      let url = v.$store.state.host + `/dokhlab/actions/drift/submit`
      v.post(url, p, response => {
        alert('Submitted Successfully!')
        window.location.href = '#/Queue'
      })
    }
  },

  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.submit {
  font-size: 16px;
}

.submit-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.submit-label {
  width: 180px;
  min-width: 180px;
  padding: 5px;
}

.submit-right {
  width: 400px;
  min-width: 400px;
  padding: 5px;
}

.submit-select {
  height: 40px;
  padding: 0 15px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #606266;
}

.submit-select:focus {
  outline: none !important;
  border: 1px solid $theme-color;
}

.submit-input {
  height: 40px;
  padding: 0 15px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #606266;
  width: 100%;
}

.submit-input:focus {
  outline: none !important;
  border: 1px solid $theme-color;
  /*
  box-shadow: 0 0 10px $theme-color;
  */
}

</style>

